// import equal from "fast-deep-equal/react";
import {Component} from "react";

export default class MHComponent extends Component {

    // shouldComponentUpdate(nextProps, nextState, nextContext) {
    //     return !equal(nextState, this.state) || !equal(nextProps, this.props) || !equal(nextContext, this.context);
    // }
}